/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const incidentTeamCommandTeamIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const incidentTeamCommandExpectedVersionExclusiveMin = 0;
export const incidentTeamCommandExpectedVersionMax = 9007199254740991;

export const IncidentTeamCommand = zod.object({
  teamId: zod.uuid().regex(incidentTeamCommandTeamIdRegExp),
  expectedVersion: zod
    .int()
    .gt(incidentTeamCommandExpectedVersionExclusiveMin)
    .max(incidentTeamCommandExpectedVersionMax),
});

export type IncidentTeamCommand = zod.input<typeof IncidentTeamCommand>;
export type IncidentTeamCommandOutput = zod.output<typeof IncidentTeamCommand>;
